var _defs, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgMatic = function SvgMatic(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 12,
    cy: 12,
    r: 12
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u8865\\u5145\\u9700\\u6C42",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "polygon",
    transform: "translate(-58.000000, -268.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u5F39\\u7A97",
    transform: "translate(18.000000, 158.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4-6",
    transform: "translate(20.000000, 92.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u7F16\\u7EC4",
    transform: "translate(20.000000, 18.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "\\u8499\\u7248",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask-2)",
    id: "matic"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.000000, 6.000000)"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2891F9",
    fillRule: "nonzero",
    points: "0 1.49999435 8 5.99998745 8 8.99998117 2.66665806 5.99998745 2.66665806 12 0 10.4999906"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2BBDF7",
    fillRule: "nonzero",
    points: "2.66665806 12 2.66665806 6.00001255 5.33331613 7.49999686 5.33331613 10.4999906"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2B6DEF",
    fillRule: "nonzero",
    points: "0 1.49999937 2.66665806 0 10.6666581 4.50000314 8 6.00001255"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2BBDF7",
    fillRule: "nonzero",
    points: "7.99997419 6.00001255 10.6666581 4.50000314 10.6666581 7.49999686 7.99997419 9.00000628"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2891F9",
    fillRule: "nonzero",
    points: "10.6666839 1.49999435 10.6666839 10.4999906 13.3333419 12 13.3333419 2.99999372"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2BBDF7",
    fillRule: "nonzero",
    points: "15.9999742 1.49999435 13.3333161 2.99999372 13.3333161 12 15.9999742 10.4999906"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "\\u8DEF\\u5F84",
    fill: "#2B6DEF",
    fillRule: "nonzero",
    points: "13.3333419 0 16 1.49999937 13.3333419 2.99999372 10.6666839 1.49999937"
  }))))))))));
};

export { SvgMatic as ReactComponent };
export default __webpack_public_path__ + "fef98ecea570c0bdf4c9799843cde4e8.svg";